import React from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import {
  ROLE_ADMIN,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';
import NotFound from '../NotFound';
import ConversationBankFlowPage from './ConversationBankFlowPage';
import ConversationBankSearch from './ConversationBankSearch';

const ConversationBank = () => {
  const location = useLocation();

  if (
    !userHasAnyRole(
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SALES,
      ROLE_SALES_MANAGER,
      ROLE_SALES_AND_INVENTORY_MANAGER
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  return (
    <Switch>
      <Route exact path="/conversation-bank">
        <ConversationBankSearch />
      </Route>
      <Route exact path="/conversation-bank/:id">
        <ConversationBankFlowPage />
      </Route>
      <Redirect to={{ pathname: '/conversation-bank', search: location.search }} />
    </Switch>
  );
};

export default ConversationBank;
